import { Col, Form, Row, message } from 'ui';
import { useUser } from 'features/auth';
import { BillingInformation, type BillingInformationValues } from '../../../../../components';
import { useGivingCreate } from '../../../../../hooks';
import { useGiveNow } from '../../../context/hooks/useGiveNow';
import { Footer } from '../footer';
import { GiveNowOptionsWithFilter } from '../give-now-options-with-filter';

export type SelectGivingFormValues = BillingInformationValues;

type P = {
  getPathToGivingDetail: (id: string) => string;
  initialValues?: SelectGivingFormValues;
  onContinue: (values: SelectGivingFormValues) => void;
};

const SelectGiving = ({ getPathToGivingDetail, initialValues, onContinue }: P) => {
  const { railsUserData: viewer } = useUser();
  const [form] = Form.useForm<SelectGivingFormValues>();
  const { viewerInfoWithCompleteAddress } = useGivingCreate();
  const { viewerItems } = useGiveNow();

  const onFinish = (values: SelectGivingFormValues) => {
    if (viewerItems.length === 0) {
      message.error('You need to add at least one item to proceed');
      return;
    }
    onContinue(values);
  };

  const hasViewerCompleteAddress = Boolean(viewerInfoWithCompleteAddress);

  return (
    <Form<SelectGivingFormValues>
      form={form}
      initialValues={{
        firstName: viewer.firstName,
        lastName: viewer.lastName,
        profileAddress: hasViewerCompleteAddress,
        ...initialValues,
      }}
      layout="vertical"
      onFinish={onFinish}
    >
      <Row gutter={['ms', 0]}>
        <Col span={12}>
          <GiveNowOptionsWithFilter getPathToGivingDetail={getPathToGivingDetail} />
        </Col>
        <Col span={12}>
          <BillingInformation<SelectGivingFormValues> hasViewerCompleteAddress={hasViewerCompleteAddress} />
        </Col>
      </Row>
      <Col span={24}>
        <Footer buttonHtmlType="submit" nextButtonText="Continue" />
      </Col>
    </Form>
  );
};

export default SelectGiving;
